import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { TemplateDialogComponent } from './TemplateDialogAngular.Component';

import { DialogAngularModule } from 'rev-shared/ui/dialog/DialogAngular.Module';
import { DialogRegistrationService } from 'rev-shared/ui/dialog/DialogRegistration.Service';
import { FormGroupAngularModule } from 'rev-shared/ui/formGroup/FormGroupAngular.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { ValidationAngularModule } from 'rev-shared/ui/validation/ValidationAngular.Module';
import { ValidationModule } from 'rev-shared/util/directives/form/validation/Validation.AngularModule';
import { VbBtnPrimaryDirective } from 'rev-shared/ui/buttons/VbBtnPrimary.Directive';
import { VbBtnSecondaryDirective } from 'rev-shared/ui/buttons/VbBtnSecondary.Directive';
import { VbUiTextInputDirective } from 'rev-shared/ui/textInput/VbUiTextInput.Directive';

@NgModule({
	declarations: [
		TemplateDialogComponent
	],
	exports:[
		TemplateDialogComponent
	],

	imports: [
		CommonModule,
		DialogAngularModule,
		FormGroupAngularModule,
		FormsModule,
		SpinnerAngularModule,
		TranslateModule,
		ValidationAngularModule,
		ValidationModule,
		VbBtnPrimaryDirective,
		VbBtnSecondaryDirective,
		VbUiTextInputDirective
	]
})
export class TemplatesAngularModule {
}

@NgModule({
})
export class TemplatesRootModule {
	constructor(dialog: DialogRegistrationService) {
		dialog.register('templateDialog', {
			component: TemplateDialogComponent
		});
	}
}
